import i18n from '@/i18n/i18n'
import FarmerDocumentsService from '@/services/public/FarmerDocumentsService'

const { t } = i18n.global

export const namespaced = true

export const actions = {
  uploadFarmerDocument({ commit, dispatch }, data) {
    const { farmerId, document, additionalDocument, type, retailerUserHash } = data
    const formData = new FormData()

    formData.append('document', document)
    if (additionalDocument) {
      formData.append('additional_document', additionalDocument)
    }
    formData.append('type', type)
    formData.append('retailer_user_hash', retailerUserHash)

    return new Promise((resolve, reject) => {
      FarmerDocumentsService.uploadDocument(
        farmerId,
        formData
      )
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
